import banner from "../assets/home/10-year-banner.png";
import bannerMobile from "../assets/home/10-year-banner-mobile.png";
import {
  isPromoBannerVisible,
  PROMO_BANNER_RSVP_URL,
} from "../common/constants";
import "./PromoBanner.scss";

function PromoBanner() {
  if (!isPromoBannerVisible()) {
    return null;
  }

  return (
    <a
      className="promo-banner"
      href={PROMO_BANNER_RSVP_URL}
      target="_blank"
      rel="noopener noreferrer"
    >
      <picture>
        <source
          media="(max-width: 768px)"
          srcSet={bannerMobile}
          width={750}
          height={144}
        />
        <img
          className="promo-banner__img"
          src={banner}
          width={2400}
          height={200}
          alt="Join us for Connie's Cakerie's 10-year customer appreciation party on Saturday, September 26 from 2 to 5pm. RSVP to reserve your tickets."
        />
      </picture>
    </a>
  );
}

export default PromoBanner;
